var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":_vm.buttonClick}},[_c('span',[_vm._v(_vm._s(_vm.text))])]),(_vm.loading)?_c('div',{staticClass:"lds-ellipsis"},[_c('div'),_c('div'),_c('div'),_c('div')]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }